import { Injectable, Output, EventEmitter } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpErrorResponse,
  HttpBackend,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import { DialogueVo } from "../data/dialogue/dialoguevo";
import { BaseUrlService } from "../service/base-url.service";
import { BehaviorSubject, Subject } from "rxjs";
import { SystemRoleData } from "../data/system-role-data";
import { UserSessionVo } from "../data/user-session-vo";
// import { EventEmitter } from 'protractor';
import { last } from "rxjs/operators";

export class DbAvailVo {
  databaseName?: string;
  datasource?: string;
}
@Injectable()
export class SystemService {
  private localHttp: HttpClient;
  private dbnameSource = new BehaviorSubject("");
  private usernameSource = new BehaviorSubject("");
  currentdbname = this.dbnameSource.asObservable();
  currentUsername = this.usernameSource.asObservable();
  userSessionVo: UserSessionVo;
  serverDate;
  serverVersion;
  tempDbName;
  changePasswordDesc;
  tempPwd;
  messageBoardCounter: number = 0;

  userLoggedOut = false;
  currentAriaPage = new Subject<string>();
  runModeDisplay = "";
  adminStatus = "";
  runMode = "";

  constructor(
    private http: HttpClient,
    private baseUrlService: BaseUrlService,
    handler: HttpBackend
  ) {
    this.localHttp = new HttpClient(handler);
  }

  setCurrentAriaPage(name) {
    this.currentAriaPage.next(name);
  }

  getCurrentAriaPage(): string {
    let name = "";
    this.currentAriaPage.pipe(last()).subscribe((d) => {
      name = Object.assign({}, d);
    });
    return name;
  }

  setdbname(dbname: string) {
    console.log(dbname);

    this.dbnameSource.next(dbname);
  }
  setUsername(username: string) {
    this.usernameSource.next(username);
  }

  reset() {
    this.userSessionVo = <UserSessionVo>{};
  }
  isAdmin(): Observable<boolean> {
    let r = this.userSessionVo["userRoleVos"].find(
      (role) => role["roleName"] === "ROLE_ACCOUNT_MANAGER"
    )["roleName"];
    console.log("isAdmin() " + r);
    if (r === "ROLE_ACCOUNT_MANAGER") {
      return Observable.of(true);
    } else {
      return Observable.of(false);
    }
  }

  hasAnyRole(roles: any): boolean {
    for (const i of Object.keys(roles)) {
      // console.log('role: ' + roles[i]);
      const r = this.userSessionVo["userRoleVos"].find(
        (role) => role["roleName"] === roles[i]
      );
      if (r) {
        return true;
      }
    }
    return false;
  }
  getDisclaimerText(): Observable<any> {
    //Getting disclaimer text from angular assets folder
    return this.localHttp.get("assets/disclaimer.txt", {
      responseType: "text",
    });
    // return this.http.get<any>(this.baseUrlService.baseUrl + 'ui/assets/disclaimer.txt');
    //Getting disclaimer text from Java Webrot/ui folder
    // return this.http.get('/ui/assets/disclaimer.txt',{responseType: 'text'});
  }

  getRunMode(): Observable<any> {
    return this.http.get("/service/system/runmode", { responseType: "text" });
  }

  getFamauthUrl(): Observable<any> {
    return this.http.get("/service/system/famauthUrl", { responseType: "text" });
  }

  getHelpUrl(): Observable<DialogueVo> {
    return this.http.get<DialogueVo>("/service/system/help-url");
  }

  getAdminStatus(): Observable<any> {
    // return this.http.get<any>(this.baseUrlService.baseRestUrl + 'system/{runmode}');
    return this.http.get("/service/system/adminstatus", {
      responseType: "text",
    });
  }

  getDatabaseList(): Observable<DialogueVo> {
    // return this.http.get<DialogueVo>(this.baseUrlService.baseRestUrl + 'system/dblist');
    return this.http.get<DialogueVo>("/service/system/dbs");
  }

  getUserList(): Observable<DialogueVo> {
    return this.http.get<DialogueVo>("/service/users/");
  }

  connectToSiteDatabase(
    databaseName: string,
    datasource: string
  ): Observable<DialogueVo> {
    // console.log('connecting');
    const dbAvailVo = new DbAvailVo();
    dbAvailVo.databaseName = databaseName;
    dbAvailVo.datasource = datasource;
    // console.log(JSON.stringify(dbAvailVo).toString());
    // return this.http.post(this.baseUrlService.baseRestUrl + 'system/connectToSiteDatabase',dbAvailVo,this.baseUrlService.postHttpOptions);
    return this.http.post(
      "/service/system/dbs/site/connect",
      dbAvailVo,
      this.baseUrlService.postHttpOptions
    );
  }

  checkSiteAdminStatus() {
    return this.http.get<DialogueVo>("/service/system/adminstatus", {
      params: null,
      responseType: "text" as "json",
    });
  }

  getSystemRoles(): Observable<DialogueVo> {
    return this.http.get<DialogueVo>("/service/system/roles");
  }

  getLastRecoverCode(dbName: String): Observable<DialogueVo> {
    return this.http.get<DialogueVo>(
      `/service/system/lastRecoverCode/${dbName}`
    );
  }

  authenticateRecoverCode(
    dbName: String,
    authCode: String
  ): Observable<DialogueVo> {
    return this.http.get<DialogueVo>(
      `/service/system/authenticateRecoverCode/${dbName},${authCode}`
    );
  }

  fixGridAriaReferences() {
    const gridBtns = document.getElementsByClassName(
      "ag-floating-filter-input"
    );
    console.log("grid references " + gridBtns.length);
  }
}
